export const environment = {
  production: true,
  //apiUrl: 'https://127.0.0.1:8000',
  //apiUrl: 'https://admin-arp.riminn.com', 
  apiUrl: 'https://admin.arp.gov.mr', 
};
